module.exports = __webpack_public_path__ + "static/pod-belong-inactive-d508d0fffaab46c4ae8a59ba0f91a1f8.jpg";